<div class="container">
    <h1>{{ pageTitle }}</h1>
</div>
<div class="title-bg-image">
    <img src="assets/img/drct-page-title.jpeg" alt="title" />
</div>
